import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';

import { Grid } from '@material-ui/core';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  aLink : {
    textDecoration: 'none',
    color : "#3f51b5"
  }
}));

function ManagingComponent() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <AppBar position="static" color="default">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <Tab label="Fusarium wilt management" {...a11yProps(0)} />
            <Tab label="Root-grafting and nematodes" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <p>
              Brief outline of key Fusarium wilt of watermelon management steps:
              </p>
              <ol>
                <li>Identify the pathogen and keep a record of disease occurrence</li>
                <li>Rotate for five to seven years (longer if possible) with non-host agronomic (corn, soybeans, forages) and vegetable (peas, sweet corn, cabbage) crops.</li>
                <li>Choose cultivars with resistance or tolerance to FON</li>
                <li>Avoid diseased materials, start transplants with disease free seeds and monitor transplants in the greenhouse as frequently as possible.</li>
                <li>Due to the soil-borne nature of FW, few fungicides are effective for control. However, some soil fumigation products like Chloropicrin can provide effective control against Fusarium wilt.</li>
                <li>Graft seedless watermelons onto squash or gourd rootstocks that are resistant to FON.</li>
                <li>Delayed transplanting for 1 to 2 weeks to help manage FW with non-optimal environments.</li>
              </ol>
            </Grid>
          </Grid>
          <Grid item xs={12}>
              <p>
              Other resources for Fusarium wilt management:
              </p>
              <ul>
                <li>
                  - <a rel="noopener noreferrer" className={classes.aLink} href="https://extension.uga.edu/publications/detail.html?number=B1485&title=Fusarium%20Wilt%20of%20Watermelon%20in%20Georgia" target="_blank">Georgia</a>
                </li>
                <li>
                  - <a rel="noopener noreferrer" className={classes.aLink} href="https://content.ces.ncsu.edu/fusarium-wilt-of-watermelon" target="_blank">North Carolina</a>
                </li>
                <li>
                  - <a rel="noopener noreferrer" className={classes.aLink} href="https://lgpress.clemson.edu/publication/integrated-management-for-fusarium-wilt-of-watermelon/" target="_blank">South Carolina</a>
                </li>
                <li>
                  - <a rel="noopener noreferrer" className={classes.aLink} href="https://www.canr.msu.edu/news/managing_diseases_caused_by_fusarium_the_case_of_watermelon_wilt" target="_blank">Michigan</a>
                </li>
                <li>
                  - <a rel="noopener noreferrer" className={classes.aLink} href="http://ipm.ucanr.edu/PMG/r116101111.html" target="_blank">California</a>
                </li>
                <li>
                  - <a rel="noopener noreferrer" className={classes.aLink} href="https://www.apsnet.org/edcenter/disandpath/fungalasco/pdlessons/Pages/FusariumWatermelon.aspx" target="_blank">American Phytopathological Society</a>
                </li>
                <li>
                  - <a rel="noopener noreferrer" className={classes.aLink} href="https://www.planthealthexchange.org/cucurbits/Pages/GROW-CUC-06-20-002.aspx" target="_blank">Plant Health Exchange</a>
                </li>
              </ul>
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Grid item xs={12}>
              <p>
              Resources for root-grafting and nematores:
              </p>
              <ul>
                <li>
                  - <a rel="noopener noreferrer" className={classes.aLink} href="https://edis.ifas.ufl.edu/publication/PI031" target="_blank">Information on Watermelon Diseases, Insect Pests, Nematodes, Weeds, and Management in Florida</a>
                </li>
                <li>
                  - <a rel="noopener noreferrer" className={classes.aLink} href="https://edis.ifas.ufl.edu/publication/PP352" target="_blank">Information on Fusarium Wilt of Watermelon</a>
                </li>
                <li>
                  - <a rel="noopener noreferrer" className={classes.aLink} href="https://edis.ifas.ufl.edu/publication/hs1257" target="_blank">Information on Root Grafting</a>
                </li>
              </ul>
          </Grid>
        </TabPanel>
      </Paper>
    </div>
  );
}

export default {
    routeProps: {
        path: '/managing',
        component: ManagingComponent
    },
    name: 'Managing Watermelon Wilt',
}
